import { render, staticRenderFns } from "./LessonPosts.vue?vue&type=template&id=d97d9ce4&scoped=true&"
import script from "./LessonPosts.vue?vue&type=script&lang=js&"
export * from "./LessonPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97d9ce4",
  null
  
)

export default component.exports